/**
 * hauer-bundles.js · seção "Bundles by bike" (sections/hauer-bundles.liquid), 13/10/2026.
 * Pedido do Bruno: "bundle for KTM, bundle for moto tal, e ia trocando sozinho os bundles".
 *  - Sem moto salva: um bundle por vez, trocando sozinho a cada N s (data-interval). Para enquanto o mouse
 *    está em cima, enquanto algo dentro tem foco, enquanto o dedo está na tela e fora da tela/aba oculta.
 *    Um toque (sem rolar), uma aba, seta, bolinha ou o botão de pausa param de vez (o botão retoma).
 *    "Reduzir movimento" ligado: não troca sozinho.
 *  - Com moto salva (window.HauerGarage.read): só os bundles cujo fit_tags casa com a moto
 *    (HauerGarage.fitState, a mesma regra dos cards e do bundle do mês). Um só: parado, sem abas.
 *    Nenhum: a seção some. Reage a hauer:garage:change (HauerGarage.onChange).
 *  - Botão: as 3 variantes num POST /cart/add.js (items[]) e abre a gaveta, como o bundle do mês.
 *  - Fotos dos slides fora da tela só baixam quando o slide (ou o anterior) fica ativo.
 * Remover: apagar este arquivo junto com a seção.
 */
(function () {
  'use strict';
  if (window.__hauerBundlesLoaded) return;
  window.__hauerBundlesLoaded = true;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* fit_tags "BMW, S1000 RR, 2019+" -> "BMW|S1000 RR|2019|open", no formato do fitState. Mesmo formato do campo do
     bundle do mês; hauer-garage.js tem bundleTags/bundleCoversRange mas não as exporta: usa as dele se um dia exportar. */
  function tagsOf(str) {
    var out = [];
    String(str || '').split(/[|,]/).forEach(function (raw) {
      var t = raw.trim(); if (!t) return;
      var m = /^(\d{4})\s*(?:\+|[-–]\s*(?:on|up|newer|present))$/i.exec(t);
      if (m) { out.push(m[1], 'open'); return; }
      m = /^(\d{4})\s*[-–]\s*(\d{4})$/.exec(t);
      if (m && +m[2] >= +m[1] && +m[2] - +m[1] < 60) { for (var y = +m[1]; y <= +m[2]; y++) out.push(String(y)); return; }
      out.push(t);
    });
    return out.join('|');
  }
  /* "All years" de uma geração (g.y1..g.y2): o bundle só vale se os anos dele cobrem a geração inteira. */
  function covers(tags, g) {
    if (!g || !g.y1 || (g.year && g.year !== 'all')) return true;
    var parts = tags.split('|');
    var ys = parts.filter(function (t) { return /^\d{4}$/.test(t); }).map(Number);
    if (!ys.length) return true;
    var lo = Math.min.apply(null, ys), hi = parts.indexOf('open') > -1 ? 9999 : Math.max.apply(null, ys);
    return lo <= g.y1 && hi >= Math.min(g.y2 || 9999, new Date().getFullYear() + 1);
  }

  function toast(msg) {
    var t = document.querySelector('.hauer-toast');
    if (!t) { t = document.createElement('div'); t.className = 'hauer-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._tm); t._tm = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  function init(root) {
    if (!root || root.dataset.hauerBbReady) return;
    root.dataset.hauerBbReady = '1';
    var $ = function (s) { return root.querySelector(s); };
    var all = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var slides = all('[data-hauer-bb-slide]');
    if (!slides.length) return;
    var tabs = all('[data-hauer-bb-tab]'), dots = all('[data-hauer-bb-dot]');
    var tablist = $('[role="tablist"]'), track = $('[data-hauer-bb-track]'), pauseBtn = $('[data-hauer-bb-pause]');
    var eyebrow = $('[data-hauer-bb-eyebrow]'), heading = $('[data-hauer-bb-heading]');
    var box = root.closest('.shopify-section') || root;
    var interval = Math.max(3, parseInt(root.dataset.interval, 10) || 6) * 1000;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var HG = null, list = slides.slice(), cur = slides[0], mine = false, timer = null, fitList = [];
    var stopped = false, hover = false, focus = false, touch = false, onScreen = false;
    // escolha do cliente: segura o bundle escolhido e volta a trocar sozinho depois de HOLD ms sem mexer
    var held = false, holdT = null, HOLD = 20000;
    function hold() { held = true; clearTimeout(holdT); holdT = setTimeout(function () { held = false; schedule(); }, HOLD); schedule(); }
    root.style.setProperty('--hb-int', (Math.max(3, parseInt(root.dataset.interval, 10) || 6)) + 's');

    function load(s) {
      if (!s) return;
      s.querySelectorAll('img[data-src]').forEach(function (im) {
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        im.src = im.dataset.src;
        im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
      });
    }
    function scrollTab(t) {
      if (!t || !tablist || tablist.scrollWidth <= tablist.clientWidth) return;
      var left = t.offsetLeft - (tablist.clientWidth - t.offsetWidth) / 2;
      if (tablist.scrollTo) tablist.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); else tablist.scrollLeft = left;
    }
    function tick() {
      var cd = cur && cur.querySelector('[data-hauer-bb-cd]');
      if (!cd) return;
      var now = new Date(), end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      if (!cd.children.length) {
        var labels = [cd.dataset.days || 'days', cd.dataset.hrs || 'hrs', cd.dataset.min || 'min', cd.dataset.sec || 'sec'];
        cd.innerHTML = labels.map(function () { return '<div><b></b><span></span></div>'; }).join('');
        labels.forEach(function (l, i) { cd.children[i].lastChild.textContent = l; });
      }
      v.forEach(function (n, i) { cd.children[i].firstChild.textContent = String(n).padStart(2, '0'); });
    }

    function canPlay() { return !stopped && !held && !reduce && !design && list.length > 1 && !hover && !focus && !touch && onScreen && !document.hidden; }
    function schedule() {
      clearTimeout(timer); timer = null;
      if (canPlay()) timer = setTimeout(function () { step(1); }, interval);
      // linha de tempo na aba ativa: recomeça do zero a cada contagem, some quando a troca está segurada
      root.classList.remove('is-running');
      if (timer) { void root.offsetWidth; root.classList.add('is-running'); }
    }
    function paintPause() {
      if (pauseBtn) pauseBtn.setAttribute('aria-pressed', stopped ? 'true' : 'false');
      root.classList.toggle('is-still', reduce || design || list.length < 2);
      if (track) track.setAttribute('aria-live', stopped || reduce ? 'polite' : 'off');
    }
    function stop() { stopped = true; paintPause(); schedule(); }

    function show(s) {
      cur = s;
      slides.forEach(function (x, i) {
        var on = x === s;
        x.classList.toggle('is-active', on);
        if (tabs[i]) { tabs[i].classList.toggle('is-active', on); tabs[i].setAttribute('aria-selected', on ? 'true' : 'false'); tabs[i].tabIndex = on ? 0 : -1; }
        if (dots[i]) dots[i].classList.toggle('is-active', on);
      });
      load(s); load(list[(list.indexOf(s) + 1) % list.length]);
      if (heading && s.dataset.heading) heading.textContent = s.dataset.heading;
      if (eyebrow) eyebrow.textContent = mine && s.dataset.eyebrowFit ? s.dataset.eyebrowFit : (root.dataset.eyebrow || '');
      tick();
      scrollTab(tabs[slides.indexOf(s)]);
      schedule();
    }
    function step(d) { var i = list.indexOf(cur); show(list[(i + d + list.length) % list.length]); }

    /* Moto salva: só os bundles que servem; nenhum = a seção some (fit_tags vazio = serve em qualquer moto). */
    function paint() {
      var g = HG && HG.read ? HG.read() : null;
      var fit = [], open = [];
      if (g && HG.fitState) slides.forEach(function (s) {
        var tags = (HG.bundleTags || tagsOf)(s.dataset.fit);
        if (!tags) open.push(s);
        else if (HG.fitState(tags, g) !== 'no' && (HG.bundleCoversRange || covers)(tags, g)) fit.push(s);
      });
      mine = !!(g && fit.length);
      fitList = fit;
      // moto salva sem bundle: mostra todos (nunca some) com o aviso de que são de outras motos
      var noFit = !!(g && HG.fitState && !fit.length && !open.length && !design);
      list = design || !g || !HG.fitState ? slides.slice() : (fit.length ? fit : (open.length ? open : slides.slice()));
      var nf = root.querySelector('[data-hauer-bb-nofit]');
      if (nf) {
        nf.hidden = !noFit;
        if (noFit) {
          var bl = (HG.label && HG.label(g)) || ((g.brand || '') + ' ' + (g.model || ''));
          var url = HG.bikeUrl ? HG.bikeUrl(g) : '/collections/all';
          var esc = function (x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
          nf.innerHTML = esc((nf.dataset.text || '').replace('{bike}', bl)) + ' <a href="' + esc(url) + '">' + esc((nf.dataset.link || '').replace('{bike}', bl)) + ' \u2192</a>';
        }
      }
      var hide = !list.length;
      box.style.display = hide ? 'none' : '';
      if (hide) box.setAttribute('data-hauer-bundle-hidden', ''); else box.removeAttribute('data-hauer-bundle-hidden');
      root.classList.remove('is-wait');
      if (hide) { clearTimeout(timer); return; }
      slides.forEach(function (s, i) {
        var on = list.indexOf(s) > -1;
        s.hidden = !on;
        if (tabs[i]) tabs[i].hidden = !on;
        if (dots[i]) dots[i].hidden = !on;
      });
      root.classList.toggle('is-single', list.length < 2);
      paintPause();
      show(list.indexOf(cur) > -1 ? cur : list[0]);
    }

    /* Escolha do cliente: para de trocar sozinho */
    function pick(i) { hold(); show(slides[i]); }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { pick(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { pick(i); }); });
    var prev = $('[data-hauer-bb-prev]'), next = $('[data-hauer-bb-next]');
    if (prev) prev.addEventListener('click', function () { stop(); step(-1); });
    if (next) next.addEventListener('click', function () { stop(); step(1); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { stopped = !stopped; if (!stopped) focus = false; paintPause(); schedule(); });
    if (tablist) tablist.addEventListener('keydown', function (e) {
      var vis = tabs.filter(function (t) { return !t.hidden; });
      var i = vis.indexOf(document.activeElement); if (i < 0) return;
      var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? vis.length - 1 : null;
      if (j === null) return;
      e.preventDefault();
      var t = vis[(j + vis.length) % vis.length]; t.focus(); pick(tabs.indexOf(t));
    });

    /* Pausas */
    root.addEventListener('mouseenter', function () { hover = true; schedule(); });
    root.addEventListener('mouseleave', function () { hover = false; schedule(); });
    // foco de teclado (o clique do mouse já é coberto pelo hover; senão o botão de play clicado seguraria a troca)
    root.addEventListener('focusin', function (e) { var kb = true; try { kb = e.target.matches(':focus-visible'); } catch (err) { /* navegador antigo: pausa */ } if (kb) { focus = true; schedule(); } });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focus = false; schedule(); } });
    var ty = null;
    root.addEventListener('touchstart', function (e) { touch = true; ty = e.touches[0] ? e.touches[0].clientY : null; schedule(); }, { passive: true });
    function touchEnd(e) {
      var t = e.changedTouches && e.changedTouches[0];
      touch = false;
      if (e.type === 'touchend' && ty !== null && t && Math.abs(t.clientY - ty) < 10) hold(); else schedule(); // toque sem rolar = segura 20 s
      ty = null;
    }
    root.addEventListener('touchend', touchEnd, { passive: true });
    root.addEventListener('touchcancel', touchEnd, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { onScreen = en[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(root);
    } else { onScreen = true; }

    /* Contagem até o último dia do mês (só a do slide ativo; o cronômetro é limpo no unload do editor) */
    if (root._cd) clearInterval(root._cd);
    root._cd = setInterval(tick, 1000);
    root._stop = function () { clearInterval(root._cd); clearTimeout(timer); };

    /* Botão: as 3 variantes no carrinho de uma vez */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-hauer-bb-add]');
      if (!btn || btn.disabled) return;
      var ids; try { ids = JSON.parse(btn.dataset.variants || '[]'); } catch (err) { ids = []; }
      if (!ids.length) return;
      stop();
      btn.disabled = true;
      if (HG && HG.track) HG.track('bundle_add', { variants: ids, count: ids.length, bike: btn.dataset.bike || '' });
      var drawer = document.querySelector('cart-drawer');
      var ds = drawer && drawer.closest('.shopify-section');
      var sections = ['cart-icon-bubble'].concat(ds ? [ds.id.replace('shopify-section-', '')] : []).join(',');
      var add = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add';
      // 04/11/2026 (teste como cliente): bundle da moto salva leva a moto com o mesmo texto da página do produto
      // (HauerGarage.label, ex. "Yamaha MT-09 / FZ-09 2021"); com textos diferentes a mesma peça virava 2 linhas no carrinho
      var bikeVal = btn.dataset.bike || '';
      try {
        var gg = HG && HG.read ? HG.read() : null;
        if (gg && HG.label && mine && fitList.indexOf(btn.closest('[data-hauer-bb-slide]')) > -1) bikeVal = HG.label(gg) || bikeVal;
      } catch (err) { /* noop */ }
      fetch(add.replace(/\.js$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { var it = { id: id, quantity: 1 }; if (bikeVal) it.properties = { Bike: bikeVal }; return it; }), sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status >= 400) throw new Error(data.description || 'error');
          if (drawer && data.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents({ sections: data.sections }, true);
          } else {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
            toast(root.dataset.successText || 'Bundle added to cart');
          }
        })
        .catch(function () { toast(root.dataset.errorText || 'Could not add the bundle. Try again.'); })
        .finally(function () { btn.disabled = false; });
    });

    /* Editor de temas: bloco selecionado = mostra o bundle dele */
    root.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target.closest ? e.target.closest('[data-hauer-bb-slide]') : null);
      if (i > -1) { stopped = true; show(slides[i]); }
    });

    function attach() {
      HG = window.HauerGarage || null;
      if (HG && HG.onChange) HG.onChange(function () { if (document.body.contains(root)) paint(); });
      else document.addEventListener('hauer:garage:change', function () { if (document.body.contains(root)) paint(); });
      paint();
    }
    if (window.HauerGarage) attach();
    else { paint(); window.addEventListener('load', function () { if (window.HauerGarage) attach(); }); }
  }

  function initIn(r) { (r && r.querySelectorAll ? r : document).querySelectorAll('[data-hauer-bb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initIn(document); }); else initIn(document);
  document.addEventListener('shopify:section:load', function (e) { initIn(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelectorAll) e.target.querySelectorAll('[data-hauer-bb]').forEach(function (r) { if (r._stop) r._stop(); });
  });
})();
